<div class="row" style="margin-top:1rem;">
  <div *ngIf="annonces.length > 0" [class]="isMobile ? 'col-12' : 'col-3'">
    <app-topannonce-bis [annonces]="annonces" [charger]="charger"></app-topannonce-bis>
  </div>
  <div [class]="isMobile || annonces.length <= 0 ? 'col-12' : 'col-9'">
    <div class="row" style="height: auto">

    </div>
    <div *ngIf="config('home1')?._view" class="row">
      <div class="col-md-12">
        <div  [class]="config('title_home1')?.param2 ? 'card ' + config('title_home1')?.param2 : 'card'">
          <div *ngIf="config('title_home1')?._view" [style]="safeCss(config('cards_colors')?.style)" id="title"  [class]="config('title_home1')?.class ? 'card-header ' + config('title_home1')?.class : 'card-header'">

            <h2 [class]="config('title_home1')?.param1 ? 'card-title ' + config('title_home1')?.param1 : ''">
              {{ config('title_home1')?.txt }}
            </h2>
          </div>
          <div class="card-body">
            <section class="row d-flex flex-row tm-pt-4 tm-pb-6">
              <div class="col-12 align-self-center my-auto align-items-center tm-page-cols-container">
                <div class="">
                  <p [class]="config('home1')?.class ? 'card-title ' + config('home1')?.class : ''"
                     [innerHtml]="config('home1')?.txt">
                  </p>
                </div>
              </div>
            </section>
          </div>
        </div>
      </div>
    </div>

    <div [matchHeight]="'card-title'" [charger]="charger" class="row d-flex justify-content-around">
      <div *ngFor="let item of baseCards; let index = index" class="col-lg-3 col-md-6 col-sm-6 ng-star-inserted">
        <div class="card card-stats" hover-class="card-grey">
          <div class="card-header card-header-rose card-header-icon">
            <div [style]="safeCss(config('cards_colors')?.style)" class="card-icon">
              <img *ngIf="item.img" width="48px" [src]="item.icon" />
              <i *ngIf="!item.img" class="material-icons">{{item.icon}}</i>
            </div>
            <p class="card-category">{{ item.title }}</p>
            <h3 class="card-title">{{ actualCards[index] }}</h3>
          </div>
          <div class="card-footer">
            <div class="stats"></div>
          </div>
        </div>
      </div>
    </div>

    <div [matchHeight]="'card-body'" [charger]="charger" class="row">
      <div *ngIf="config('home2')?._view" class="col-md-6">
        <div [class]="config('title_home2')?.class ? 'card ' + config('title_home2')?.class : 'card'">
          <div *ngIf="config('title_home2')?.param4 === '0'" [style]="safeCss(config('cards_colors')?.style)" class="card-header card-header-grey">
            <h2 class="card-title text-center" style="color: white; font-family: 'Bjorn Regular', sans-serif; ">{{ config('title_home2')?.txt }}</h2>
          </div>
          <div *ngIf="config('title_home2')?.param4 === '1'" class="card-header card-header-image">
            <img [alt]="config('title_home2')?.param3" class="img" [src]="config('title_home2')?.param2">
          </div>
          <div class="card-body">
            <h4 *ngIf="config('title_home2')?.param4 === '1'" [class]="config('title_home2')?.param1">
              <b>{{ config('title_home2')?.txt }}</b>
            </h4>
            <div class="card-content">
              <span [class]="config('home2')?.class ? 'card-title ' + config('home2')?.class : ''"
                    [innerHtml]="getSafeHTML | functionCaller : config('home2')?.txt" [style]="safeCss(config('home2')?.style)">
              </span>
            </div>
          </div>
        </div>
      </div>
      <div *ngIf="config('home3')?._view" class="col-md-6">
        <div [class]="config('title_home3')?.class ? 'card ' + config('title_home3')?.class : 'card'">
          <div *ngIf="config('title_home3')?.param4 === '0'" [style]="safeCss(config('cards_colors')?.style)" class="card-header card-header-grey">
            <h2 class="card-title text-center" style="color: white; font-family: 'Bjorn Regular', sans-serif; ">{{ config('title_home3')?.txt }}</h2>
          </div>
          <div *ngIf="config('title_home3')?.param4 === '1'" class="card-header card-header-image">
            <img [alt]="config('title_home3')?.param3" class="img" [src]="config('title_home3')?.param2">
          </div>
          <div class="card-body">
            <h4 *ngIf="config('title_home3')?.param4 === '1'" [class]="config('title_home3')?.param1">
              <b>{{ config('title_home3')?.txt }}</b>
            </h4>
            <div class="card-content">
              <span [class]="config('home3')?.class ? 'card-title ' + config('home3')?.class : ''"
                    [innerHtml]="getSafeHTML | functionCaller : config('home3')?.txt" [style]="safeCss(config('home3')?.style)">
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
